module.exports = __webpack_public_path__ + "static/media/SativaDomCG.2731937f.png";